import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import * as actions from '../actions';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import sampleCombine from 'xstream/extra/sampleCombine';
import delay from 'xstream/extra/delay';
import HEADER_FUNCTIONS from '../utils/functions/headers';

const REQUEST_CLAIM_CATEGORIES = 'requestClaimCategories';
const REQUEST_CLAIM_CATEGORIES_BY_POLICYTYPE =
    'requestClaimCategoriesByPolicyType';

export function requestClaimCategories(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.FETCH_CLAIM_CATEGORIES,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: GENERAL_FUNCTIONS.getBaseURL() + 'api/claimCategory',
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_CLAIM_CATEGORIES,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_CLAIM_CATEGORIES)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchClaimCategoriesSuccess(response)
                : actions.fetchClaimCategoriesFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function requestClaimTypesWhenClaimCategoriesAreEmpty(sources) {
    const state$ = sources.STATE;
    const policyType$ = state$.map(state => state.answer.answer.policyType);

    const action$ = sources.ACTION.filter(
        action =>
            action.type ===
            ActionTypes.FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE_SUCCESS,
    )
        .filter(action => action.payload && !action.payload.body.data)
        .compose(sampleCombine(policyType$))
        .map(([action, policyType]) =>
            actions.fetchFormTypesByPolicyAndCategoryCode({
                policyTypeCode: policyType,
                claimCategoryCode: '___',
            }),
        );
    return {
        ACTION: action$,
    };
}

export function requestClaimCategoriesByPolicyType(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action =>
            action.type === ActionTypes.FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: `${GENERAL_FUNCTIONS.getBaseURL()}api/claimCategory/PolicyTypeCode/${action.payload.policyTypeCode}/claimApplication`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_CLAIM_CATEGORIES_BY_POLICYTYPE,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(
        REQUEST_CLAIM_CATEGORIES_BY_POLICYTYPE,
    )
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchClaimCategoriesByPolicyTypeSuccess(response)
                : actions.fetchClaimCategoriesByPolicyTypeFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
